import { useEffect } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import analytics from 'lib/analytics';

export default function TicketsRedirect() {
  const router = useRouter();

  useEffect(() => {
    const go = async () => {
      // Homepage, not /events: when WordPress is down the events page can fail too,
      // while the homepage is served from the static cache.
      let target = '/';
      let apiOk = false;
      // A hung WordPress (504 after ~10s at nginx) left visitors on this blank page;
      // give up quickly and use the default instead.
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 4000);
      try {
        const res = await fetch('https://turnstyleonline.com/wp-json/dw/v1/tickets-redirect', {
          signal: controller.signal,
        });
        apiOk = res.ok;
        if (res.ok) {
          const data = await res.json();
          if (data && data.url && typeof data.url === 'string' && data.url.trim() !== '') {
            target = data.url;
          }
        }
      } catch (e) {
        // ignore fetch errors and timeouts; we'll use the default
      } finally {
        clearTimeout(timeout);
      }

      // Always log and redirect, even on error
      if (typeof window !== 'undefined') {
        const gtag = window.gtag || ((...args) => { /* no-op if GA not loaded */ });
        gtag('event', 'page_view', { page_title: 'Tickets', page_location: window.location.href, page_path: '/tickets' });
        gtag('event', 'tickets_redirect', { destination: target, api_ok: apiOk });
      }

      // Only an off-site redirect (a ticket seller) counts as a Google Ads
      // conversion; an on-site target like the event page is just a page view,
      // and the real conversion fires if the visitor then clicks Get Tickets.
      let isExternal = false;
      try {
        isExternal = new URL(target, window.location.origin).origin !== window.location.origin;
      } catch (e) {
        // malformed URL from the redirect API; still redirect, just don't count it
      }
      if (isExternal) {
        analytics.trackGoogleAdsConversion({ event_destination: target, event_page: '/tickets' });
      }

      router.replace(target);
    };
    go();
  }, [router]);

  // Minimal shell while redirecting
  return (
    <Head>
      <title key="page-title">Tickets - Turnstyle</title>
      <meta key="robots" name="robots" content="noindex, follow" />
    </Head>
  );
}


